<template>
    <div>
        <v-overlay :value="overlay" :style="`width:${bgWidth}px;`" :dark="false" :color="overlayColor" :opacity="0.95">
            <QrDialogPage
                @cancel="onCancel"
                @success="onSuccess"
                :class="animationClass"
            />
        </v-overlay>

        <!-- If both icon and label exist, place them in a vertical stack -->
        <div v-if="icon && label" class="icon-label-vertical" @click="onOpen">
            <v-icon style="font-size: 50px;">{{ icon }}</v-icon>
            <span>{{ label }}</span>
        </div>

        <!-- If only icon exists -->
        <v-icon v-else-if="icon" @click="onOpen" x-large>{{ icon }}</v-icon>

        <!-- If only label exists -->
        <div v-else-if="label" @click="onOpen">{{ label }}</div>
    </div>
</template>

<script>
import CONFIG from "../../constants/config";
import {layoutMixin} from "../../utils/layout-mixin";
import {spotMixin} from "../../utils/spot-mixin";
import {EspotoQREvaluator, EspotoQRType} from "../../utils/espoto-qr-evaluator.mjs";
import QrDialogPage from "../../views/dashboard/QrDialogPage";

export default {
    mixins: [layoutMixin, spotMixin],
    components:{
        QrDialogPage
    },
    props:{
        spot:{},
        disabled:{ //TODO: einbauen
            type:Boolean,
            default:false
        },
        icon:{
            type:String,
            default:null
        },
        label:{
            type:String,
            default:null
        },
        fctIsValidCode:{
            type:Function,
            default:null
        }
    },
    data() {
        return {
            overlay:false,
            overlayColor:'#333',
            code:'',
            animationClass:'',
            animationFailedDuration:1000,
            animationSuccessDuration:1500
        }
    },
    methods: {
        onOpen(){
            this.overlay=true;
        },
        onCancel(){
            this.overlay=false;
        },
        onSuccess(data){
            //TODO meldung anzeigen
            if(this.isValidCode(data)){
                this.showSuccessAnimation().then(()=>{
                    this.overlay=false;
                    this.$emit('success',data);
                });
            }else{
                this.showFailAnimation();
            }
        },
        isValidCode(scannedUrl){
            //Example intelligent qr: https://qr.tabgame.de/?data=https://espoto.tabgametest.de/system/launch/a/espoto_app_secret/gametype/1/e/353/d/qr_6297&size=6
            //Example classic qr: https://qr.tabgame.de/?data=qr_6297&size=6
            if(typeof(scannedUrl)=="string"){
                // console.log("scannedUrl", scannedUrl);

                if(typeof(this.fctIsValidCode)=="function"){
                    // console.log("fctIsValidCode", scannedUrl);
                    return this.fctIsValidCode(scannedUrl)
                }else{
                    const qrEvaluator = new EspotoQREvaluator(scannedUrl, this);
                    // console.log("qrEvaluator", qrEvaluator)
                    if (qrEvaluator.espotoQRType === EspotoQRType.TaskQR) {
                        return this.spot.id == qrEvaluator.readTaskIdFromQRCode();
                    } else {
                        return false;
                    }
                }
            }
            return false;
        },
        getValidQrCodeParameter(sUrl){
            let res=null;
            if(typeof(sUrl)=="string"){
                let ambersandParamsPos=sUrl.indexOf('&');
                if(ambersandParamsPos>-1){
                    sUrl=sUrl.slice(0,ambersandParamsPos);
                }
                res=sUrl.replace('qr_','').replace('wp_','')
            }
            return res;
        },
        showFailAnimation(){
            return new Promise((resolve)=>{
                this.animationClass='shake-horizontal';
                this.overlayColor=CONFIG.getRed();
                setTimeout(()=>{
                    this.qrIsInValid=false;
                    this.resetOverlayAnimation();
                    resolve();
                },this.animationFailedDuration);
            });
        },
        showSuccessAnimation(){
            return new Promise((resolve)=>{
                this.animationClass='bounce';
                this.overlayColor=CONFIG.getGreen();
                setTimeout(()=>{
                    this.resetOverlayAnimation();
                    resolve();
                },this.animationSuccessDuration);
            });
        },

        resetOverlayAnimation(){
            this.animationClass='';
            this.overlayColor="#333";
        }
    },
}
</script>

<style lang="scss" scoped>
.icon-label-vertical {
    display: flex;
    flex-direction: column;
    align-items: center; /* centers them horizontally */
    justify-content: center;
}

.bounce {
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-name: bounce;
    animation-timing-function: ease;

}
@keyframes bounce {
    0%   { transform: translateY(0); }
    30%  { transform: translateY(-100px); }
    50%  { transform: translateY(0); }
    100% { transform: translateY(0); }
}

.shake-horizontal {
    -webkit-animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
    animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
}

@-webkit-keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
@keyframes shake-horizontal {
    0%,
    100% {
        -webkit-transform: translateX(0);
        transform: translateX(0);
    }
    10%,
    30%,
    50%,
    70% {
        -webkit-transform: translateX(-10px);
        transform: translateX(-10px);
    }
    20%,
    40%,
    60% {
        -webkit-transform: translateX(10px);
        transform: translateX(10px);
    }
    80% {
        -webkit-transform: translateX(8px);
        transform: translateX(8px);
    }
    90% {
        -webkit-transform: translateX(-8px);
        transform: translateX(-8px);
    }
}
</style>